export const getSingularProductName = name => {
  switch(name.toLowerCase()) {
    case 'Beach Day Passes':
      return `Beach Day Pass`;
    case 'Pool and Beach Day Passes':
      return `Pool and Beach Day Pass`;
    case 'day passes':
      return `Day Pass`;
    case 'cabanas':
      return `Cabana`;
    case 'spa passes':
      return `Spa Pass`;
    case 'daybeds':
      return `Daybed`;
    case 'addons':
      return `Addon`;
    case 'fitness passes':
      return `Fitness Pass`;
    case 'events':
      return `Events`;
    default:
      return `Day Pass`;
  }
};
